var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerMenuW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12.000046,
    viewBox: "0 0 18 12.000046",
    fill: "none",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 0,12.000046 v -2 h 18 v 2 z m 0,-5.00005 v -2 h 18 v 2 z m 0,-5 V 0 h 18 v 1.999996 z",
    fill: "#1C1B1F",
    id: "path1",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenuW);
export default __webpack_public_path__ + "static/media/hamburger-menu-w.ba67a2b45f395b4da16d8ef3b987cc33.svg";
export { ForwardRef as ReactComponent };